import React from 'react';
import logo from "../../assets/images/logo_small.jfif";
import facebook from "../../assets/images/facebook.png";
import instagram from "../../assets/images/instagram.png";
import "./style.css";
import ContactData from "../ContactData/ContactData";

export default function Footer() {
  return (
    <footer className="footer relative pt-1 text-center mt-4" style={{ background: '#1a1a1a', color: '#e5e5e5' }}>
      <div className="container mx-auto">
        <div className="sm:flex sm:mt-8">
          <div className="mt-8 sm:mt-0 sm:w-full sm:px-8 flex flex-col md:flex-row justify-between items-center md:items-start">
            <div className="flex flex-col flex-0 justify-center pt-5">
              <img src={logo} alt="Marmolería Colaiacovo" className="logo rounded-lg opacity-90" loading="lazy" decoding="async" />
            </div>
            <div className="flex flex-col pt-5 mobile:px-5">
              <span className="font-bold uppercase mb-3 text-xs tracking-widest" style={{ color: '#ff7a00' }}>Contacto</span>
              <div className="sm:text-left text-center" style={{ color: '#ccc' }}>
                <ContactData />
              </div>
            </div>
            <div className="flex flex-col pt-5">
              <span className="font-bold uppercase mb-3 text-xs tracking-widest" style={{ color: '#ff7a00' }}>Atención</span>
              <p style={{ color: '#ccc' }}>
                Lúnes a viernes de 09:00 a 12:00 y de 14:00 a 17:00
              </p>
            </div>
            <div className="flex flex-col pt-5">
              <span className="font-bold uppercase mb-3 text-xs tracking-widest" style={{ color: '#ff7a00' }}>Seguinos</span>
              <div className="flex gap-4 justify-center md:justify-start">
                <a href="https://www.facebook.com/sanitarioslaquila" target="_blank" rel="noopener noreferrer" aria-label="Seguinos en Facebook" className="transition duration-200 ease-in-out hover:opacity-70">
                  <img src={facebook} alt="" aria-hidden="true" className="h-10 w-10" loading="lazy" decoding="async" />
                </a>
                <a href="https://www.instagram.com/sanitarios_laquila/" target="_blank" rel="noopener noreferrer" aria-label="Ver nuestro Instagram" className="transition duration-200 ease-in-out hover:opacity-70">
                  <img src={instagram} alt="" aria-hidden="true" className="h-10 w-10" loading="lazy" decoding="async" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-6" style={{ borderTop: '1px solid #333', marginTop: '24px' }}>
        <div className="mt-4 flex flex-col items-center pb-4">
          <div className="sm:w-2/3 text-center py-3">
            <p className="text-sm font-bold mb-2" style={{ color: '#666' }}>
              © {new Date().getFullYear()} — <a href="https://www.linkedin.com/in/gino-colaiacovo-947156bb/" rel="noopener noreferrer" target="_blank" style={{ color: '#ff7a00' }}>Powered by Gino Colaiacovo</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
